import { render, staticRenderFns } from "./trainList.vue?vue&type=template&id=148ff1dc&"
import script from "./trainList.vue?vue&type=script&lang=ts&"
export * from "./trainList.vue?vue&type=script&lang=ts&"
import style0 from "./trainList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports